<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import Loading from "@/components/table-loading";
import appConfig from "@/app.config";
import { fetchComponentData, onFiltered } from "@/helpers/crud-func";

/*
 *  Rating component
 */
export default {
  page: {
    title: "Rating",
    meta: [{ name: "description" }],
  },
  components: { Layout, PageHeader, Loading },
  data() {
    return {
      // page header
      title: "Rating",
      items: [],
      // crud functions
      fetchLink: appConfig.rating.list,
      componentData: [],
      // table properties
      transProps: { name: "table-list" },
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortDesc: false,
      hover: true,
      isBusy: true,
      fields: [
        { key: "id", label: "id", sortable: true },
        { key: "username", label: "User Name" },
        { key: "rating", label: "Rating" },
        { key: "feedback", label: "Feedback", sortable: false },
        { key: "date", label: "Date"}
      ],
    };
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
  computed: {
    rows() {
      return this.componentData.length; // Total no. of records
    },
  },
  methods: {},
  created() {
    this.fetchComponentData = fetchComponentData.bind(this);
    this.onFiltered = onFiltered.bind(this);
  },
  mounted() {
    this.fetchComponentData();
  },
};
</script>

<template>
  <Layout> 
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search ..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="mb-0" id="rating_page_table">
              <b-table
                primary-key="id"
                :tbody-transition-props="transProps"
                :items="componentData"
                :fields="fields"
                :hover="hover"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              </b-table>
              <div class="table_feedback">
                <div
                  class="empty_records text-center"
                  v-if="componentData.length == 0 && !isBusy"
                >
                  <p>There are no records to show.</p>
                </div>
                <div class="empty_filtered text-center" v-if="rows > 0 && totalRows == 0">
                  <p>There are no records matching your request.</p>
                </div>
                <div class="loading" v-if="isBusy">
                  <Loading></Loading>
                </div>
              </div>
              <!-- table_feedback -->
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
/deep/ #rating_page_table .table td {
  word-break: break-all !important; 
  max-width: 250px !important; 
}
</style>
